import { createTheme } from "@mui/material/styles";

// define the theme for your project
export const customTheme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
      contrastText: "white",
    },
  },
});
